const rooturl =
  process.env.REACT_APP_LIBRARY_ROOT_URL ||
  "https://cloud.aideapro.ai/middlewareblob/common/aideapro/";

const CHARACTERS = [
  {
    id: "file-7416972898256",
    url: rooturl + "library/KKarakter/eerkek1.png",
    name: "eerkek1.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-94593645836050",
    url: rooturl + "library/KKarakter/eerkek10.png",
    name: "eerkek10.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-32726187453629",
    url: rooturl + "library/KKarakter/eerkek11.png",
    name: "eerkek11.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-5608946876112",
    url: rooturl + "library/KKarakter/eerkek12.png",
    name: "eerkek12.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-99933801427255",
    url: rooturl + "library/KKarakter/eerkek13.png",
    name: "eerkek13.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-52147435135892",
    url: rooturl + "library/KKarakter/eerkek14.png",
    name: "eerkek14.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-41236837589363",
    url: rooturl + "library/KKarakter/eerkek15.png",
    name: "eerkek15.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-3617811815116",
    url: rooturl + "library/KKarakter/eerkek16.png",
    name: "eerkek16.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-44808161871830",
    url: rooturl + "library/KKarakter/eerkek17.png",
    name: "eerkek17.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-89818332489493",
    url: rooturl + "library/KKarakter/eerkek18.png",
    name: "eerkek18.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-80902824414925",
    url: rooturl + "library/KKarakter/eerkek19.png",
    name: "eerkek19.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-18101088043617",
    url: rooturl + "library/KKarakter/eerkek2.png",
    name: "eerkek2.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-84072366303756",
    url: rooturl + "library/KKarakter/eerkek20.png",
    name: "eerkek20.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-45207522848860",
    url: rooturl + "library/KKarakter/eerkek21.png",
    name: "eerkek21.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-96852896378940",
    url: rooturl + "library/KKarakter/eerkek22.png",
    name: "eerkek22.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-7468477674067",
    url: rooturl + "library/KKarakter/eerkek23.png",
    name: "eerkek23.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-12054147785550",
    url: rooturl + "library/KKarakter/eerkek3.png",
    name: "eerkek3.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-47009916617976",
    url: rooturl + "library/KKarakter/eerkek4.png",
    name: "eerkek4.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-10916823032760",
    url: rooturl + "library/KKarakter/eerkek5.png",
    name: "eerkek5.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-35983088160156",
    url: rooturl + "library/KKarakter/eerkek6.png",
    name: "eerkek6.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-90664697248049",
    url: rooturl + "library/KKarakter/eerkek7.png",
    name: "eerkek7.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-59496019033711",
    url: rooturl + "library/KKarakter/eerkek8.png",
    name: "eerkek8.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-40508438775642",
    url: rooturl + "library/KKarakter/eerkek9.png",
    name: "eerkek9.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-14649456347208",
    url: rooturl + "library/KKarakter/erkek1.png",
    name: "erkek1.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-81639525496736",
    url: rooturl + "library/KKarakter/erkek2.png",
    name: "erkek2.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-66861095242280",
    url: rooturl + "library/KKarakter/erkek3.png",
    name: "erkek3.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-21433459078649",
    url: rooturl + "library/KKarakter/erkek4.png",
    name: "erkek4.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-16281851748880",
    url: rooturl + "library/KKarakter/erkek5.png",
    name: "erkek5.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-53085131496882",
    url: rooturl + "library/KKarakter/erkek6.png",
    name: "erkek6.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-58115624473143",
    url: rooturl + "library/KKarakter/erkek7.png",
    name: "erkek7.png",
    keywords: "erkek,man",
    mimetype: "image/png",
  },
  {
    id: "file-2146563585339",
    url: rooturl + "library/KKarakter/kadin1.png",
    name: "kadin1.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-85385667957823",
    url: rooturl + "library/KKarakter/kadin10.png",
    name: "kadin10.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-77825261792834",
    url: rooturl + "library/KKarakter/kadin11.png",
    name: "kadin11.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-36849843211361",
    url: rooturl + "library/KKarakter/kadin12.png",
    name: "kadin12.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-8332940308332",
    url: rooturl + "library/KKarakter/kadin13.png",
    name: "kadin13.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-78265842070069",
    url: rooturl + "library/KKarakter/kadin14.png",
    name: "kadin14.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-46141862074910",
    url: rooturl + "library/KKarakter/kadin15.png",
    name: "kadin15.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-354078501992",
    url: rooturl + "library/KKarakter/kadin16.png",
    name: "kadin16.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-25095683339385",
    url: rooturl + "library/KKarakter/kadin17.png",
    name: "kadin17.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-3738601944422",
    url: rooturl + "library/KKarakter/kadin18.png",
    name: "kadin18.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-13056971140583",
    url: rooturl + "library/KKarakter/kadin19.png",
    name: "kadin19.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-61169313853077",
    url: rooturl + "library/KKarakter/kadin2.png",
    name: "kadin2.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-19100896164198",
    url: rooturl + "library/KKarakter/kadin20.png",
    name: "kadin20.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-22358175107489",
    url: rooturl + "library/KKarakter/kadin21.png",
    name: "kadin21.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-97089105280475",
    url: rooturl + "library/KKarakter/kadin22.png",
    name: "kadin22.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-29104814632271",
    url: rooturl + "library/KKarakter/kadin23.png",
    name: "kadin23.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-68894579973096",
    url: rooturl + "library/KKarakter/kadin24.png",
    name: "kadin24.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-17188289961756",
    url: rooturl + "library/KKarakter/kadin25.png",
    name: "kadin25.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-91860645332203",
    url: rooturl + "library/KKarakter/kadin26.png",
    name: "kadin26.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-94957602907536",
    url: rooturl + "library/KKarakter/kadin27.png",
    name: "kadin27.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-88531453294257",
    url: rooturl + "library/KKarakter/kadin28.png",
    name: "kadin28.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-83386783664010",
    url: rooturl + "library/KKarakter/kadin29.png",
    name: "kadin29.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-94821994081070",
    url: rooturl + "library/KKarakter/kadin3.png",
    name: "kadin3.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-94548677701250",
    url: rooturl + "library/KKarakter/kadin30.png",
    name: "kadin30.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-99193756564795",
    url: rooturl + "library/KKarakter/kadin31.png",
    name: "kadin31.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-4492644610299",
    url: rooturl + "library/KKarakter/kadin32.png",
    name: "kadin32.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-62983048947470",
    url: rooturl + "library/KKarakter/kadin33.png",
    name: "kadin33.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-85105183832558",
    url: rooturl + "library/KKarakter/kadin34.png",
    name: "kadin34.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-34850096780521",
    url: rooturl + "library/KKarakter/kadin35.png",
    name: "kadin35.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-72683307693701",
    url: rooturl + "library/KKarakter/kadin36.png",
    name: "kadin36.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-6254306140488",
    url: rooturl + "library/KKarakter/kadin37.png",
    name: "kadin37.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-85710712519458",
    url: rooturl + "library/KKarakter/kadin38.png",
    name: "kadin38.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-97073961422",
    url: rooturl + "library/KKarakter/kadin39.png",
    name: "kadin39.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-84779362751117",
    url: rooturl + "library/KKarakter/kadin4.png",
    name: "kadin4.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-9777466478355",
    url: rooturl + "library/KKarakter/kadin40.png",
    name: "kadin40.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-63944609772247",
    url: rooturl + "library/KKarakter/kadin41.png",
    name: "kadin41.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-51834814034832",
    url: rooturl + "library/KKarakter/kadin42.png",
    name: "kadin42.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-4749744680413",
    url: rooturl + "library/KKarakter/kadin43.png",
    name: "kadin43.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-49791926568453",
    url: rooturl + "library/KKarakter/kadin44.png",
    name: "kadin44.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-58623765173016",
    url: rooturl + "library/KKarakter/kadin45.png",
    name: "kadin45.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-42406789326570",
    url: rooturl + "library/KKarakter/kadin46.png",
    name: "kadin46.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-51970319588840",
    url: rooturl + "library/KKarakter/kadin47.png",
    name: "kadin47.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-30462598526124",
    url: rooturl + "library/KKarakter/kadin48.png",
    name: "kadin48.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-66579268944621",
    url: rooturl + "library/KKarakter/kadin49.png",
    name: "kadin49.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-27089835004768",
    url: rooturl + "library/KKarakter/kadin5.png",
    name: "kadin5.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-28743661671843",
    url: rooturl + "library/KKarakter/kadin50.png",
    name: "kadin50.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-79322531200644",
    url: rooturl + "library/KKarakter/kadin51.png",
    name: "kadin51.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-35063854238345",
    url: rooturl + "library/KKarakter/kadin52.png",
    name: "kadin52.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-37073368269656",
    url: rooturl + "library/KKarakter/kadin53.png",
    name: "kadin53.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-97970649722110",
    url: rooturl + "library/KKarakter/kadin54.png",
    name: "kadin54.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-99559789690080",
    url: rooturl + "library/KKarakter/kadin55.png",
    name: "kadin55.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-3454487895631",
    url: rooturl + "library/KKarakter/kadin6.png",
    name: "kadin6.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-1078558924387",
    url: rooturl + "library/KKarakter/kadin7.png",
    name: "kadin7.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-52270899876957",
    url: rooturl + "library/KKarakter/kadin8.png",
    name: "kadin8.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-57837034938960",
    url: rooturl + "library/KKarakter/kadin9.png",
    name: "kadin9.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-39515142467607",
    url: rooturl + "library/KKarakter/kkadin1.png",
    name: "kkadin1.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-80765775417522",
    url: rooturl + "library/KKarakter/kkadin10.png",
    name: "kkadin10.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-27333235197160",
    url: rooturl + "library/KKarakter/kkadin11.png",
    name: "kkadin11.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-65513943484317",
    url: rooturl + "library/KKarakter/kkadin12.png",
    name: "kkadin12.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-65775558746916",
    url: rooturl + "library/KKarakter/kkadin13.png",
    name: "kkadin13.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-74201056509940",
    url: rooturl + "library/KKarakter/kkadin14.png",
    name: "kkadin14.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-386328576987",
    url: rooturl + "library/KKarakter/kkadin2.png",
    name: "kkadin2.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-58765378333224",
    url: rooturl + "library/KKarakter/kkadin3.png",
    name: "kkadin3.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-12008548638232",
    url: rooturl + "library/KKarakter/kkadin4.png",
    name: "kkadin4.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-70261021366939",
    url: rooturl + "library/KKarakter/kkadin5.png",
    name: "kkadin5.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-93368985349359",
    url: rooturl + "library/KKarakter/kkadin6.png",
    name: "kkadin6.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-32043257068763",
    url: rooturl + "library/KKarakter/kkadin7.png",
    name: "kkadin7.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-19867393894006",
    url: rooturl + "library/KKarakter/kkadin8.png",
    name: "kkadin8.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
  {
    id: "file-96233105675588",
    url: rooturl + "library/KKarakter/kkadin9.png",
    name: "kkadin9.png",
    keywords: "kadın,woman",
    mimetype: "image/png",
  },
];

export const CHARACTER_ITEMS = CHARACTERS;
